import type { BulkOrderUpdateJobSummaryResponse } from '@api/useBulkOrderUpdate/types'

interface PriorityNameRendererProps {
  data: BulkOrderUpdateJobSummaryResponse
}

export function PriorityNameRenderer({ data }: PriorityNameRendererProps) {
  const { priority_name, priority } = data

  // Use priority_name if available, otherwise fall back to priority number
  const displayText = priority_name || `Priority ${priority || 0}`

  // Color coding by priority level
  const getPriorityColor = (priorityValue: number) => {
    if (priorityValue >= 100) return 'text-red-600 font-medium' // High priority
    if (priorityValue >= 50) return 'text-orange-600' // Medium priority
    return 'text-gray-600' // Low priority
  }

  return <span className={`text-xs ${getPriorityColor(priority || 0)}`}>{displayText}</span>
}
